import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'normalize.css'
import Vue2Editor from "vue2-editor";
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Vue2Editor);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
